<img _ngcontent-pge-c105="" src="../../assets/images/myvista-logo-white.png" alt="logo" class="hoverLogo">
<div class="iwg-form-dialog iwg-contact">
    <mat-toolbar class="mat-iwgGreen-theme">
      <div class="mat-toolbar-tools">
        <span class="vista-contctus">Contact Information</span>
        <span flex></span>
        <mat-icon class="mat-icon-button closeX" (click)="hide()">close</mat-icon>
      </div>
    </mat-toolbar> 
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
    <mat-dialog-content style="overflow: hidden;padding:0px;display: table;width: 100%;">
        <div class="d-flex layout-column flex md-padding w-100 pad-16">
            <div flex class="content-responsive">
                <p class="iwg-regular-value" style="line-height:1.5em;">                   
                    In order to verify your identity during password reset, MyVista will need to 
                    provide you an access code to your mobile phone. Please provide a mobile phone number below.
                </p>
            </div>
            <div layout="row" class="vista-contactpopup">
                <span flex  fxFlex="30" style="max-height: 40px;margin: 19px 10px 0px 0px">
                   
                                        <app-country-select  
                                        name="CountrySel"
                                        [(ngModel)]="preselectedCountry"
                                        [preselectedItemId]="preselectedCountry"
                                        [isRequired]="true"
                                        [alltext]="'Please Select'"
                                        helptext=""
                                        [idOnly]="false"
                                        [showcallingcode]="true"
                                        [labeltext]="'Country Code'">
                                    </app-country-select>
                                </span>
                <span flex fxFlex="34" style="max-height: 40px;margin: 22px 0px 0px 0px;">
                    <mat-form-field class="mat-form-field vista-login-label">
                        <input type="text" matInput name="mobileNumber" [(ngModel)]="mobileNumber" placeholder="Mobile Phone Number" required>
                    </mat-form-field>
                </span>
            </div>

           
                <div class="myvista-contact">
                    <button mat-button class="md-primary md-raised iwg-md-raised" style="color:rgba(255,255,255,0.87);background-color:#224d95; min-width: 88px;" (click)="updateMobileNumber()">Ok
                    </button>
                </div>
        </div>
    </mat-dialog-content>
</div>